import { render, staticRenderFns } from "./LandingWishlistNL.vue?vue&type=template&id=0ade0986&scoped=true"
import script from "./LandingWishlistNL.vue?vue&type=script&lang=js"
export * from "./LandingWishlistNL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ade0986",
  null
  
)

export default component.exports